export class LookupValue {
  id: number;
  description: string;

  constructor(id: number = 0, description: string = "") {
    this.id = id;
    this.description = description;
  }
}



// WEBPACK FOOTER //
// ./src/models/common/lookup-value.ts